// Classification-yard schematic (SVG viewBox 0 0 1000 H).
// One entry line -> fans out (curved throat) from a single hub into N PARALLEL
// horizontal tracks (aligned start/end) -> fans back into a single exit line.
function sampleCubic(p0, p1, p2, p3, n) {
  const pts = [];
  for (let i = 0; i <= n; i++) {
    const t = i / n;
    const mt = 1 - t;
    pts.push({
      x: mt * mt * mt * p0.x + 3 * mt * mt * t * p1.x + 3 * mt * t * t * p2.x + t * t * t * p3.x,
      y: mt * mt * mt * p0.y + 3 * mt * mt * t * p1.y + 3 * mt * t * t * p2.y + t * t * t * p3.y,
    });
  }
  return pts;
}

export function computeGeometry(n, large) {
  const rowH = large ? 50 : 44;
  const padY = large ? 38 : 28;
  const ww = large ? 32 : 28;
  const wh = large ? 20 : 17;
  const spacing = ww + 7;
  const W = 1000;
  const H = padY * 2 + (n - 1) * rowH;
  const centerY = H / 2;

  const entryX = 16;
  const leftHubX = 96;
  const trackStartX = 218;
  const trackEndX = 782;
  const rightHubX = 904;
  const exitX = 984;

  const y = (i) => padY + i * rowH;
  const E = { x: entryX, y: centerY };
  const EX = { x: exitX, y: centerY };
  const leftHub = { x: leftHubX, y: centerY };
  const rightHub = { x: rightHubX, y: centerY };

  // bezier control points for throats
  const leftThroatPts = (i) =>
    sampleCubic(
      leftHub,
      { x: leftHubX + 72, y: centerY },
      { x: trackStartX - 72, y: y(i) },
      { x: trackStartX, y: y(i) },
      7
    );
  const rightThroatPts = (i) =>
    sampleCubic(
      { x: trackEndX, y: y(i) },
      { x: trackEndX + 72, y: y(i) },
      { x: rightHubX - 72, y: centerY },
      rightHub,
      7
    );

  const leftThroatD = (i) =>
    `M ${leftHubX} ${centerY} C ${leftHubX + 72} ${centerY}, ${trackStartX - 72} ${y(i)}, ${trackStartX} ${y(i)}`;
  const rightThroatD = (i) =>
    `M ${trackEndX} ${y(i)} C ${trackEndX + 72} ${y(i)}, ${rightHubX - 72} ${centerY}, ${rightHubX} ${centerY}`;

  const padIn = 10;
  const slots = Math.max(2, Math.floor((trackEndX - trackStartX - padIn * 2) / spacing));
  const slotsCount = () => slots;
  // slot 0 = far (right) end; wagons entering from the left are pushed deep first,
  // so an arriving wagon never has to pass through parked ones.
  const slotX = (i, k) => trackEndX - padIn - ww / 2 - k * spacing;
  const rest = (i, k) => ({ x: slotX(i, k), y: y(i) });

  const entryHead = (i) => [E, ...leftThroatPts(i)];
  const exitTail = (i) => [...rightThroatPts(i), EX];

  const arrivingRoute = (i, k) => [...entryHead(i), rest(i, k)];
  const departingRoute = (i, k) => [rest(i, k), ...exitTail(i)];
  const shuntRoute = (iA, kA, iB, kB) => [
    rest(iA, kA),
    ...[...leftThroatPts(iA)].reverse(),
    ...leftThroatPts(iB),
    rest(iB, kB),
  ];

  return {
    n, large, rowH, padY, ww, wh, spacing, W, H, centerY, entryX, exitX,
    leftHubX, trackStartX, trackEndX, rightHubX,
    y, slotsCount, slotX, rest,
    leftThroatD, rightThroatD,
    entryHead, exitTail, arrivingRoute, departingRoute, shuntRoute,
  };
}
